import script from "./Watermark.vue?vue&type=script&lang=ts&setup=true"
export * from "./Watermark.vue?vue&type=script&lang=ts&setup=true"

import "./Watermark.vue?vue&type=style&index=0&id=84b0bf24&scoped=true&lang=less"

import exportComponent from "/var/lib/jenkins/workspace/运营辅助平台正式前端/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-84b0bf24"]])

export default __exports__